import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Container } from 'react-bootstrap';

export default function Contrato() {
    const { id } = useParams();
    const [contrato, setContrato] = useState({});
    const [loading, setLoading] = useState(true);
    const [linkContrato, setLinkContrato] = useState("");
    const [expandedAditivoId, setExpandedAditivoId] = useState(null);
    const [aditivos, setAditivos] = useState([])

    const toggleAditivo = (id) => {
        setExpandedAditivoId(expandedAditivoId === id ? null : id);
    };

    useEffect(() => {
        setLoading(true);
        // Fetch main contract data
        fetch(`https://www.alepe.pe.gov.br/contratos/list.php?ID=${id}`).then(result => {
            result.json().then((jsonResult) => {
                setLinkContrato(jsonResult.data[0].LinkArquivo.replace(
                    'http://sistemas.tce.pe.gov.br/audinArquivos/licon/contrato/778/',
                    'https://www.alepe.pe.gov.br/contratos/downloads/'
                  ));
                setContrato(jsonResult.data[0]);
                // Fetch aditivos data
                fetchAditivos(jsonResult.data[0].AnoContrato, jsonResult.data[0].NumeroContrato);
            });
        });
    }, [id]);

    const fetchAditivos = (anoContrato, numeroContrato) => {
        fetch(`https://www.alepe.pe.gov.br/contratos/aditivos/list.php?anocontrato=${anoContrato}&numerocontrato=${numeroContrato}`)
            .then(response => response.json())
            .then(data => {
                let updatedAditivos = data.data.map(aditivo => {
                    return {
                        ...aditivo,
                        LinkArquivo: aditivo.LinkArquivo.replace(
                            "http://sistemas.tce.pe.gov.br/audinArquivos/licon/contrato/termoAditivo/778/", 
                            'https://www.alepe.pe.gov.br/contratos/aditivos/downloads/'
                        )
                    };
                });

                updatedAditivos = updatedAditivos.sort((a, b) => {
                    if (a.AnoTermoAditivo === b.AnoTermoAditivo) {
                        // Descending order for NumeroTermoAditivo if AnoTermoAditivo is the same
                        return b.NumeroTermoAditivo - a.NumeroTermoAditivo;
                    }
                    // Descending order for AnoTermoAditivo
                    return b.AnoTermoAditivo - a.AnoTermoAditivo;
                });
                
                
                setAditivos(updatedAditivos || []);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching aditivos:", error);
                setLoading(false);
            });
    };
    

    const renderAditivosTable = () => {
        return (
            <>
            <Table striped bordered hover>
                <tbody>
                    {aditivos.map(aditivo => (
                        <React.Fragment key={aditivo.Id}>
                            {/* Header row */}
                            <tr onClick={() => toggleAditivo(aditivo.Id)} style={{ cursor: 'pointer' }}>
                                <td colSpan="3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>
                                        {aditivo.NumeroTermoAditivo}/{aditivo.AnoTermoAditivo}
                                    </span>
                                    <i className={`fa ${expandedAditivoId === aditivo.Id ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true"></i>
                                </td>
                            </tr>
                            {/* Detail row */}
                            {expandedAditivoId === aditivo.Id && (
                                <tr>
                                    <td colSpan="3">
                                        {/* Render additional details here */}
                                        <p><strong>Justificativa:</strong> {aditivo.Justificativa}</p>
                                        <p><strong>Vigência:</strong> {aditivo.Vigencia}</p>
                                        <p><strong>Link:</strong> <a href={aditivo.LinkArquivo} target="_blank" rel="noopener noreferrer">Visualizar em PDF</a></p>
                                        {/* Add more details as needed */}
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </Table>
            </>);
    };
    
    

    return <div>
    <p><small>Você está em <a href="/financas">Prestação de Contas</a> / <a href="/financas/contratos">Contratos</a> / Contrato {contrato.NumeroContrato}/{contrato.AnoContrato}</small></p>
    <div className="proposicao-list-header">
        <Container>
            <Row className="text-center">
            <Col>
                <h2 className="title">Contrato {contrato.NumeroContrato}/{contrato.AnoContrato}</h2>
            </Col>
            </Row>
        </Container>
        </div>

        <div>
        <div>
            <h3 className="title">Objeto</h3>
        </div>
        <div>
            <p style={{ textAlign: 'justify' }}>{contrato.Objeto}</p>
        </div>
        </div>
        <br /><br />
        <div>
        <div className='table-responsive'>
            <h3 className="title">Informações</h3>
            <Table>
            <thead>
                <tr>
                    <th colSpan="3">Vigência do Contrato: {contrato.Vigencia}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="td-bold">Número Processo Licitatório:</td>
                    <td style={{ minWidth: '585px' }}>
                        {contrato.NumeroProcesso ? `${contrato.NumeroProcesso}/${contrato.AnoProcesso}` : '-'}
                    </td>
                </tr>
                <tr>
                    <td className="td-bold">Modalidade:</td>
                    <td style={{ minWidth: '585px' }}>{contrato.TipoProcesso || '-'}</td>
                </tr>
                <tr>
                    <td className="td-bold">Empresa:</td>
                    <td style={{ minWidth: '585px' }}>{contrato.RazaoSocial || '-'}</td>
                </tr>
                <tr>
                    <td className="td-bold">CPF/CNPJ:</td>
                    <td>{contrato.NumeroDocumento || '-'}</td>
                </tr>
                <tr>
                    <td className="td-bold">Valor:</td>
                    <td>{contrato.Valor ? `R$ ${contrato.Valor.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}` : '-'}</td>
                </tr>
                <tr>
                    <td className="td-bold">Anexos:</td>
                <td>
                    <a href={linkContrato} target="_blank" rel="noopener noreferrer">Visualizar em PDF</a>
                </td>
                </tr>
            </tbody>
            </Table>
        </div>
        </div>
        {aditivos && aditivos.length ? <div>
            <h3 className="title">Aditivos</h3>
            {renderAditivosTable()}
        </div> : null}
    </div>;
}